import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

interface IBackdropLoader {
  color?: "inherit" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

const BackdropLoader: React.FC<IBackdropLoader> = ({ color }) => {
  //   const [open, setOpen] = React.useState(true);
  //   const handleClose = () => {
  //     setOpen(false);
  //   };
  //   const handleOpen = () => {
  //     setOpen(true);
  //   };

  return (
    <Backdrop
      sx={{ color: "var(--primary-foreground)", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={true}
      // onClick={handleClose}
    >
      <CircularProgress color={color || "primary"} />
    </Backdrop>
  );
};

export default BackdropLoader;
